module.exports = __webpack_public_path__ + "img/shequ-8.182586bb.png";